var _a;
import * as yup from 'yup';
import fieldValidationMessageIds from './validationMessages';
import { createAuthFormHook } from './createAuthFormHook';
export var ELoginWithEmailFormField;
(function (ELoginWithEmailFormField) {
    ELoginWithEmailFormField["EMAIL_OR_USERNAME"] = "emailOrUsername";
    ELoginWithEmailFormField["PASSWORD"] = "password";
})(ELoginWithEmailFormField || (ELoginWithEmailFormField = {}));
var required = fieldValidationMessageIds.required;
export var loginWithEmailFormSchema = yup.object((_a = {},
    _a[ELoginWithEmailFormField.EMAIL_OR_USERNAME] = yup.string().required(required),
    _a[ELoginWithEmailFormField.PASSWORD] = yup.string().required(required),
    _a));
export var useLoginWithEmailForm = createAuthFormHook(loginWithEmailFormSchema);
